export default {"src":"/_next/static/media/Facebook.45f0f820.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};